"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUser = void 0;
var parseUser = function (_a) {
    var analytics_id = _a.analytics_id, company = _a.company, email = _a.email, first_name = _a.first_name, id = _a.id, last_name = _a.last_name, name = _a.name, nickname = _a.nickname, uid = _a.uid, image_url = _a.image_url, job_title = _a.job_title, phone = _a.phone;
    return ({
        analyticsId: analytics_id,
        company: company,
        email: email,
        firstName: first_name,
        id: id,
        lastName: last_name,
        name: name,
        nickname: nickname,
        oxygenId: uid,
        imageUrl: image_url,
        jobTitle: job_title,
        phone: phone,
    });
};
exports.parseUser = parseUser;
